module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/pt-br-card-drag.12369bade9ca44bf159b.gif";